export default {
  labels: {
    selectOne: '请选择一个选项',
    selectAll: '请选择所有适用的选项',
    typeResponse: '请在下面的文本框中输入您的回答。',
    recordResponse: '请录制一段回答该问题的内容。',
    enterNumeric: '在下方字段中输入一个数字回答。',
    rateResponseScale: '请根据提供的量表对您的回答进行评分。',
    sliderMinimum: '最小值：{value}',
    sliderMaximum: '最大值：{value}',
    selectOneOptionRow: '请在每一行中选择一个选项。',
    selectAllOptionsRow: '请在每一行中选择所有适用的选项。',
    dragAndDropResponse: '拖放选项以按偏好排序。',
    rankOrderDesktopInstruction: '拖放项目以对其排名，或使用+按钮将项目添加到列表。使用箭头按钮重新排序，或使用删除按钮删除项目。',
    alert: "警告",
    error: '请输入介于 {min} 和 {max} 之间的数字。',
    cameras: '摄像头',
    microphones: '麦克风',
    recording: '录制',
    noDevicesFound: '未找到设备',
    camera: '摄像头',
    microphone: '麦克风',
    stopRecording: '停止录制',
    startRecording: '开始录制',
    disableCamera: '禁用摄像头',
    enableCamera: '启用摄像头',
    disableMicrophone: '禁用麦克风',
    enableMicrophone: '启用麦克风',
    settings: '设置',
    recordingProgress: '录制进度',
    playbackProgress: '播放进度',
    play: '播放',
    pause: '暂停',
    stop: '停止',
    record: '录制',
    recordAgain: '重新录制',
    retry: '重试',
    done: '完成',
    minRecordTime: '请录制一个{min}秒的回答。',
    enlargeImage: '放大图片',
    enlargedImage: '已放大的图片',
    close: '关闭',
    zoomIn: '放大',
    zoomOut: '缩小',
    resetZoom: '重置缩放',
    zoomLevel: '缩放 {percentage}%',
    imagePosition: '第 {current} 张，共 {total} 张',
    previousImage: '上一张图片',
    nextImage: '下一张图片',
    imageLoading: '正在加载图片',
    imageLoadFailed: '无法加载图片',
  },
  noSelection: "未选择",
  actions: {
    increase: '增加',
    decrease: '减少'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: '问卷预览已终止',
      titleCompleted: '问卷预览已完成',
      previewModeWarning: '此页面仅在预览模式下可见，不会向实际受访者显示。',
      reachedEndPoint: '本问卷已到达结束点。',
      reachedEndPointCompleted: '本预览已到达结束点。',
      returnToModify: '返回上一题以修改您的答案并测试不同的问卷路径。',
      logic: '逻辑'
    }  }
}
